import {
  Button,
  ButtonGroup,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  RequestForInvoicingTypeEnum as RfiTypeEnum,
  useInvoiceProjectByCurrentMonthBillingPlanMutation,
} from "@src/__generated__/graphql";
import { Banner } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { onError } from "@src/utils/apollo";
import Router from "next/router";

interface BillingApproachingProps {
  projectId: string;
}

export const BillingApproaching = ({ projectId }: BillingApproachingProps) => {
  const [create, { loading }] =
    useInvoiceProjectByCurrentMonthBillingPlanMutation({
      onCompleted({ invoiceProjectByCurrentMonthBillingPlan }) {
        if (invoiceProjectByCurrentMonthBillingPlan?.id) {
          Router.push({
            pathname: "/invoices/for-invoicing/edit",
            query: { id: invoiceProjectByCurrentMonthBillingPlan.id },
          });
        }
      },
      ...onError(),
    });

  const onAction = (type: RfiTypeEnum) => {
    create({ variables: { projectId, type } });
  };

  return (
    <Banner
      size="sm"
      title={t`Billing day is approaching`}
      status="info"
      px="3"
      py="2"
      customAction={
        <Menu>
          <ButtonGroup isAttached>
            <Button
              isLoading={loading}
              onClick={() => onAction(RfiTypeEnum.Invoice)}
              size="sm"
            >
              <Trans>Create</Trans>
            </Button>
            <MenuButton
              as={IconButton}
              aria-label={t`Other options`}
              icon={<Icon name="chevron-down" />}
              size="sm"
            />
          </ButtonGroup>
          <Portal>
            <MenuList>
              <MenuItem onClick={() => onAction(RfiTypeEnum.Invoice)}>
                <Trans>Invoice</Trans>
              </MenuItem>
              <MenuItem onClick={() => onAction(RfiTypeEnum.Proforma)}>
                <Trans>Proforma</Trans>
              </MenuItem>
            </MenuList>
          </Portal>
        </Menu>
      }
    />
  );
};
